
import * as dom from './../../modules/wpstg-dom-utils';

/**
 * Push Table Selection
 */
export default class WpstgPushTableSelection {
  constructor(
      workflowSelector = '#wpstg-workflow',
      inputSelector = '#wpstg_select_tables_pushing',
      wpstgObject = wpstg,
  ) {
    this.workflow = dom.qs(workflowSelector);
    this.inputSelector = inputSelector;
    this.input = dom.qs(inputSelector);
    this.wpstgObject = wpstgObject;
    this.cloneID = this.input.getAttribute('data-clone');
    this.tablePrefix = this.input.getAttribute('data-prefix');
    this.isNetwork = this.input.getAttribute('data-network') === 'true';
    this.areAllTablesChecked = true;

    this.init();
  }

  addEvents() {
    dom.addEvent(document.body, 'click', '.wpstg-button-show-tables', (target) => {
      this.showAllTables();
    });

    dom.addEvent(document.body, 'click', '.wpstg-button-db-prefix', () => {
      this.selectDefaultTables();
    });

    dom.addEvent(document.body, 'click', '.wpstg-button-unselect', () => {
      this.toggleTableSelection();
    });

    dom.addEvent(document.body, 'change', this.inputSelector, () => {
      this.countSelectedTables();
    });
  }

  init() {
    this.addEvents();
  }

  showAllTables() {
    fetch(this.wpstgObject.ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      body: new URLSearchParams({
        action: 'wpstg_push_tables',
        accessToken: this.wpstgObject.accessToken,
        nonce: this.wpstgObject.nonce,
        clone: this.cloneID,
        tables: this.getSelectedTables(),
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((response) => {
      if (response.ok) {
        return response.json();
      }

      return Promise.reject(response);
    }).then((data) => {
      // Reload current page if successful.
      if ('undefined' !== typeof (data.success) && data.success) {
        this.input.innerHTML = data.content;
        dom.fadeOut(dom.qs('.wpstg-button-show-tables'), 300);

        this.countSelectedTables();
        return;
      }

      // There will be message probably in case of error
      if ('undefined' !== typeof (data.message)) {
        this.notyf.error(data.message);
        return;
      }

      this.notyf.error(this.wpstgObject.i18n['somethingWentWrong']);
    }).catch((error) => {
      console.warn(this.wpstgObject.i18n['somethingWentWrong'], error);
    });
  }

  selectDefaultTables() {
    const options = this.input.querySelectorAll('.wpstg-db-table');
    const multisitePattern = '^' + this.tablePrefix + '([^0-9])_*';
    const singleSitePattern = '^' + this.tablePrefix;
    options.forEach((option) => {
      const name = option.getAttribute('name', '');
      if (this.wpstgObject.isMultisite === '1' && !this.isNetwork && name.match(multisitePattern)) {
        option.setAttribute('selected', 'selected');
      } else if (this.wpstgObject.isMultisite === '' && name.match(singleSitePattern)) {
        option.setAttribute('selected', 'selected');
      } else if (this.wpstgObject.isMultisite === '1' && this.isNetwork && name.match(singleSitePattern)) {
        option.setAttribute('selected', 'selected');
      } else {
        option.removeAttribute('selected');
      }
    });

    this.countSelectedTables();
  }

  toggleTableSelection() {
    if (false === this.areAllTablesChecked) {
      this.input.querySelectorAll('.wpstg-db-table').forEach((option) => {
        option.setAttribute('selected', 'selected');
      });

      this.workflow.querySelector('.wpstg-button-unselect').innerHTML = 'Unselect All';
      this.areAllTablesChecked = true;
    } else {
      this.input.querySelectorAll('.wpstg-db-table').forEach((option) => {
        option.removeAttribute('selected');
      });
      this.workflow.querySelector('.wpstg-button-unselect').innerHTML = 'Select All';
      this.areAllTablesChecked = false;
    }

    this.countSelectedTables();
  }

  getSelectedTables() {
    const tables = [];
    this.input.querySelectorAll('option:checked').forEach((option) => {
      tables.push(option.getAttribute('name'));
    });

    return tables;
  }

  countSelectedTables() {
    const tablesCount = this.input.querySelectorAll('option:checked').length;
    const tablesCountElement = dom.qs('#wpstg-tables-count');
    if (tablesCount === 0) {
      tablesCountElement.classList.add('danger');
      tablesCountElement.innerHTML = this.wpstgObject.i18n['noTableSelected'];
    } else {
      tablesCountElement.classList.remove('danger');
      tablesCountElement.innerHTML = this.wpstgObject.i18n['tablesSelected'].replace('{d}', tablesCount);
    }
  }
}
